import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTimes} from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import i18next from 'i18next';

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      hidden: true,
      windowWidth: 0,
      activeShow: false,
      errorMessage: '',
      fieldRequired: false,
    };
    this.toggleShow = this.toggleShow.bind(this);
    this.update = this.update.bind(this);
    window.addEventListener('resize', this.update);
  }

  componentDidMount() {
    if (this.props.history.location.state !== undefined) {
      // this.setState({activeShow: this.props.history.location.state.show});
    }
    this.update();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.update);
  }

  update() {
    this.setState({
      windowWidth: window.innerWidth,
    });
  }

  toggleShow() {
    this.setState({hidden: !this.state.hidden});
  }

  getEmail(e) {
    this.setState({email: e.target.value});
  }

  verifyEmail() {
    if (this.state.email !== '') {
      axios.get(`${window.env.REACT_APP_API_URL}/registration-service/valid/forgot/email/${this.state.email}`)
          .then((res) => {
            this.setState({errorMessage: ''});
            this.props.userService.doPasswordRecover(this.state.email);
            this.props.history.push('/check-password');
          })
          .catch((error) => {
            this.setState({errorMessage: error?.response?.data ?? 'Request failed'});
          });
    } else {
      this.setState({fieldRequired: true});
    }
  }

  recoverPassword() {
    // if (this.state.windowWidth < 768) {
    this.verifyEmail();
    // }
    if (this.state.email !== '' && this.state.errorMessage === '') {
      this.props.userService.doPasswordRecover(this.state.email);
      this.props.history.push('/check-password');
    }
  }

  render() {
    const {windowWidth, activeShow, errorMessage, fieldRequired} = this.state;
    return (
      <React.Fragment>
        { windowWidth > 767 ?
                    <div className={'forgotPassword-desktop dimenticato'}>
                      <div>
                        <div className={'header-popup flex space-between '}>
                          <p className={'p0 m-0 accent-color'}>{i18next.t('Hai dimenticato la password?')}</p>
                          <div>
                            <FontAwesomeIcon icon={faTimes}
                              className={'light-grey pointer'}
                              onClick={() => this.props.history.push('/')}
                            />
                          </div>
                        </div>
                        <form className={'body-popup'}>
                          <p className={'p0 test-p'}>{i18next.t('Se hai dimenticato la password, inserisci qui sotto il tuo indirizzo email di registrazione. Provvederemo a inviarti il link e le istruzioni per recuperare la password persa.')}</p>
                          <input autoComplete={'none'}
                            className={'input-email ' + (fieldRequired && this.state.email === '' ? 'required' : '')}
                            type={'email'}
                            placeholder={i18next.t('Inserisci qui il tuo indirizzo email')}
                            pattern={'[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$'}
                            onChange={(e) => this.getEmail(e)}
                            onBlur={() => this.verifyEmail()}
                          />
                          {errorMessage !== '' &&
                            <p className={'pink m-0'}>{errorMessage}</p>
                          }
                          <div className={'button-wrapper'}>
                            <div className={'button'}
                              onClick={() => this.recoverPassword()}>
                                  {i18next.t('INVIA RICHIESTA')}
                            </div>
                          </div>
                        </form>
                        <div className={'footer-popup '}>
                          <p className={'p0'}>{i18next.t('Non ti ricordi l\'indirizzo email contatta il')}{' '}<span>{' '}{i18next.t('Support')}</span></p>
                        </div>
                      </div>
                    </div> :
                    <div className={'forgotPassword-mobile dimenticato ' + (activeShow ? 'active' : '')}>
                      <div>
                        <div className={'header-popup flex space-between '}>
                          <p className={'p0 m-0 light-grey p20'}>{i18next.t('Hai dimenticato la password?')}</p>
                          <div>
                            <FontAwesomeIcon icon={faTimes}
                              className={'light-grey pointer'}
                              onClick={() => this.props.history.push('/')}
                            />
                          </div>
                        </div>
                        <form className={'body-popup'}>
                          <p className={'p0 test-p'}>{i18next.t('Se hai dimenticato la password, inserisci qui sotto il tuo indirizzo email di registrazione. Provvederemo a inviarti il link e le istruzioni per recuperare la password persa.')}</p>
                          <input autoComplete={'none'}
                            type={'email'}
                            className={'input-email relative ' + (fieldRequired && this.state.email === '' ? 'required' : '')}
                            placeholder={i18next.t('Inserisci qui il tuo indirizzo email')}
                            pattern={'[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$'}
                            onChange={(e) => this.getEmail(e)}
                          />

                          <div className={'button-wrapper'}>
                            <div className={'button'}
                              tabIndex={0}
                              onClick={() => this.recoverPassword()}
                            >{i18next.t('INVIA RICHIESTA')}</div>
                          </div>
                        </form>
                        <div className={'footer-popup '}>
                          <p className={'p0'}>{i18next.t('Non ti ricordi l\'indirizzo email contatta il')}<span>{' '}{i18next.t('Support')}</span></p>
                        </div>

                      </div>

                    </div>
        }
      </React.Fragment>
    );
  }
}

export default ForgotPassword;
